/**
 * 员工多平台一键发帖接口（用户态, accessToken 鉴权）。
 * 内部大群工具栏「发帖」入口使用: 员工各自绑定平台账号 → 发帖 → 看数据 → 回评论。
 * 员工身份由后端从登录态取, 前端不传 userId。
 * @author niebu
 */
import http from './httpRequest.js'

export default {
	// 平台清单(含是否开通+我的绑定状态): [{platform,label,enabled,reason,bound,status,accountId,displayName}]
	platforms() {
		return http({ url: '/social/platforms', method: 'GET' });
	},
	// 发起绑定: 授权型平台返回 {status:0, approvalUrl}; 凭证型平台提交 input 即绑定
	bind(platform, input) {
		return http({ url: '/social/bind', method: 'POST', data: { platform, input } });
	},
	// 刷新绑定状态(授权型平台轮询授权结果): {status, accountId, displayName, message}
	refreshBind(platform) {
		return http({ url: '/social/bind/refresh', method: 'POST', data: { platform } });
	},
	// 解绑某平台
	unbind(platform) {
		return http({ url: '/social/unbind', method: 'POST', data: { platform } });
	},
	// 发帖/回复: {platform, text, channel?, parentExternalId?, embedUrls?} → 帖子记录
	publish(data) {
		return http({ url: '/social/publish', method: 'POST', data });
	},
	// 我的发帖记录(platform 可空=全部, 倒序)
	myPosts(platform, limit) {
		const params = { limit: limit || 50 };
		if (platform) params.platform = platform;
		return http({ url: '/social/posts', method: 'GET', params });
	},
	// 刷新单帖互动数据(点赞/转发/回复)
	refreshMetrics(postId) {
		return http({ url: '/social/posts/refresh', method: 'POST', data: { postId } });
	},
	// 我的评论收件箱(onlyUnreplied=true 只看未回复)
	myComments(platform, onlyUnreplied, limit) {
		const params = { onlyUnreplied: !!onlyUnreplied, limit: limit || 50 };
		if (platform) params.platform = platform;
		return http({ url: '/social/comments', method: 'GET', params });
	},
	// 主动拉取平台评论入库(webhook 兜底), 返回新增条数
	pullComments(platform) {
		return http({ url: '/social/comments/pull', method: 'POST', data: { platform } });
	},
	// 回复某条评论: 以评论为父帖发一条回复
	replyComment(commentId, text) {
		return http({ url: '/social/comments/reply', method: 'POST', data: { commentId, text } });
	}
}
